import { put, takeEvery, select } from 'redux-saga/effects';
import { showNotification } from 'react-admin';
import * as constants from '../../constants/index'
import { REMOVE_FLIGHT_REQUESTS_FAILURE, REMOVE_FLIGHT_REQUESTS_SUCCESS, GetFlightRequestsListQuery } from './types';
import { getAllFlightRequests, changeSelectedRequests } from './action';

const getSelectedFilters = (state: constants.AppState) => state.selectedFilters

function* removeFlightRequests(action: any) {
    if (action.payload.error) {
        yield put(showNotification(action.payload.error, 'error'));
    } else {
        yield put(showNotification('ra.messages.successfulOperation', 'success'))

        const user = JSON.parse(localStorage.getItem('user') as string);
        const selectedFilters = (yield select(getSelectedFilters)) as constants.AppState
        let query: any = new GetFlightRequestsListQuery();
        query.pageIndex = 0;
        query.pageSize = constants.configuration.DEFAULT_PAGE_SIZE;

        if (selectedFilters['FlightRequestList'] !== undefined) {
            Object.keys(selectedFilters['FlightRequestList']).map(function (index: any) {
                if (!selectedFilters['FlightRequestList'][index].disabled) {
                    if (index === 'dateTimeFrom') {
                        query.dateFrom = selectedFilters['FlightRequestList'][index].values[0].value;
                    }
                    if (index === 'dateTimeThru') {
                        query.dateTo = selectedFilters['FlightRequestList'][index].values[0].value;
                    }
                    if (index === 'flightType') {
                        query.flightType = selectedFilters['FlightRequestList'][index].values[0].value;
                    }
                    if (index === 'requestNumber') {
                        query.requestNumber = selectedFilters['FlightRequestList'][index].values[0].value;
                    }
                    if (index === 'sourceCity') {
                        query.sourceCity = selectedFilters['FlightRequestList'][index].values[0].label;
                    }
                    if (index === 'destinationCity') {
                        query.destinationCity = selectedFilters['FlightRequestList'][index].values[0].label;
                    }
                    if (index === 'staying') {
                        query.staying = selectedFilters['FlightRequestList'][index].values[0].value;
                    }
                    if (index === 'flightRequestStatus') {
                        query.status = selectedFilters['FlightRequestList'][index].values[0].value;
                    }
                    if (index === 'airline') {
                        query.airline = selectedFilters['FlightRequestList'][index].values[0].value;
                    }
                }
            });
        }

        yield put(getAllFlightRequests(user.group, query));
    }
    yield put(changeSelectedRequests([], 'FlightRequestList'));
}

export default function* flightRequestsListSaga() {
    yield takeEvery([
        REMOVE_FLIGHT_REQUESTS_FAILURE,
        REMOVE_FLIGHT_REQUESTS_SUCCESS
    ], removeFlightRequests);
}
